(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var registry = new WeakMap();
    var SMOOTH_SCROLL_MS = 650; // safe upper bound for the browser's smooth scroll animation

    function getStep(track) {
      var first = track.querySelector('.hero-carousel-section__tile:not(.hero-carousel-section__tile--clone)');
      if (!first) return track.clientWidth || 1;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return first.offsetWidth + gap;
    }

    function getOriginalTiles(track) {
      return Array.prototype.slice.call(
        track.querySelectorAll(
          '.hero-carousel-section__tile:not(.hero-carousel-section__tile--clone):not(.hero-carousel-section__tile--empty)'
        )
      );
    }

    function getVisibleCount(track) {
      var step = getStep(track);
      if (!step) return 1;
      return Math.max(1, Math.round(track.clientWidth / step));
    }

    function clearClones(track) {
      var clones = track.querySelectorAll('.hero-carousel-section__tile--clone');
      for (var i = 0; i < clones.length; i++) clones[i].remove();
    }

    function ensureClones(track) {
      var originals = getOriginalTiles(track);
      if (originals.length < 2) {
        clearClones(track);
        return 0;
      }
      var visible = getVisibleCount(track);
      var needed = Math.min(visible, originals.length);

      var existing = track.querySelectorAll('.hero-carousel-section__tile--clone');
      if (existing.length === needed) return needed;

      clearClones(track);

      for (var i = 0; i < needed; i++) {
        var clone = originals[i].cloneNode(true);
        clone.classList.add('hero-carousel-section__tile--clone');
        clone.setAttribute('aria-hidden', 'true');
        // Strip Shopify editor attributes so the editor doesn't track clones as blocks
        var attrs = Array.prototype.slice.call(clone.attributes);
        for (var a = 0; a < attrs.length; a++) {
          if (attrs[a].name.indexOf('data-shopify') === 0) {
            clone.removeAttribute(attrs[a].name);
          }
        }
        // Make any links inside the clone non-tabbable
        var links = clone.querySelectorAll('a');
        for (var l = 0; l < links.length; l++) {
          links[l].setAttribute('tabindex', '-1');
          links[l].setAttribute('aria-hidden', 'true');
        }
        track.appendChild(clone);
      }
      return needed;
    }

    function instantScrollTo(track, left) {
      // CSS sets scroll-behavior: smooth, which makes scrollTo({behavior:'auto'})
      // animate. Temporarily override the inline style for a real teleport.
      var prev = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = left;
      // Force layout flush before restoring, so the new scroll-behavior takes effect
      void track.offsetHeight;
      track.style.scrollBehavior = prev;
    }

    function smoothScrollTo(track, left) {
      track.scrollTo({ left: left, behavior: 'smooth' });
    }

    function init(root) {
      if (!root || registry.has(root)) return;
      var track = root.querySelector('[data-hero-carousel-track]');
      if (!track) return;
      var prev = root.querySelector('[data-hero-carousel-prev]');
      var next = root.querySelector('[data-hero-carousel-next]');
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-carousel-dot]'));

      var state = {
        paused: false,
        autoplayTimer: null,
        animating: false,
        animationTimer: null,
        scrollSyncRaf: null
      };

      // Build clones for seamless looping
      ensureClones(track);

      function updateActiveDot() {
        if (!dots.length) return;
        var stepPx = getStep(track);
        if (!stepPx) return;
        var originals = getOriginalTiles(track);
        if (!originals.length) return;
        var idx = Math.round(track.scrollLeft / stepPx) % originals.length;
        if (idx < 0) idx += originals.length;
        for (var i = 0; i < dots.length; i++) {
          var isActive = i === idx;
          dots[i].classList.toggle('is-active', isActive);
          dots[i].setAttribute('aria-selected', isActive ? 'true' : 'false');
        }
      }

      function goToSlide(index) {
        if (state.animating) return;
        var stepPx = getStep(track);
        if (!stepPx) return;
        var originals = getOriginalTiles(track);
        if (!originals.length) return;
        var target = (index % originals.length) * stepPx;
        state.animating = true;
        smoothScrollTo(track, target);
        state.animationTimer = setTimeout(function () {
          state.animating = false;
          updateActiveDot();
        }, SMOOTH_SCROLL_MS);
      }

      var onScroll = function () {
        if (state.scrollSyncRaf) return;
        state.scrollSyncRaf = requestAnimationFrame(function () {
          state.scrollSyncRaf = null;
          updateActiveDot();
        });
      };
      track.addEventListener('scroll', onScroll, { passive: true });

      var dotHandlers = [];
      dots.forEach(function (dot, i) {
        var handler = function () { goToSlide(i); };
        dot.addEventListener('click', handler);
        dotHandlers.push(handler);
      });

      function originalsWidth() {
        var originals = getOriginalTiles(track);
        return originals.length * getStep(track);
      }

      function step() {
        return getStep(track);
      }

      function scrollBy(direction) {
        if (state.animating) return; // prevent overlapping animations
        var stepPx = step();
        if (!stepPx) return;
        var origWidth = originalsWidth();
        var current = track.scrollLeft;

        if (direction > 0) {
          var target = current + stepPx;
          state.animating = true;
          smoothScrollTo(track, target);
          // If this scroll moves us into clone territory, teleport back after animation completes
          if (target >= origWidth - 1) {
            state.animationTimer = setTimeout(function () {
              instantScrollTo(track, target - origWidth);
              state.animating = false;
            }, SMOOTH_SCROLL_MS);
          } else {
            state.animationTimer = setTimeout(function () {
              state.animating = false;
            }, SMOOTH_SCROLL_MS);
          }
        } else {
          // Backward
          var prevTarget = current - stepPx;
          if (prevTarget < 0) {
            // Teleport forward into the equivalent end-of-track position, then smooth-scroll backward
            instantScrollTo(track, current + origWidth);
            // Allow layout to settle, then smooth-scroll one step back
            requestAnimationFrame(function () {
              state.animating = true;
              smoothScrollTo(track, track.scrollLeft - stepPx);
              state.animationTimer = setTimeout(function () {
                state.animating = false;
              }, SMOOTH_SCROLL_MS);
            });
          } else {
            state.animating = true;
            smoothScrollTo(track, prevTarget);
            state.animationTimer = setTimeout(function () {
              state.animating = false;
            }, SMOOTH_SCROLL_MS);
          }
        }
      }

      var onPrev = function () { scrollBy(-1); };
      var onNext = function () { scrollBy(1); };
      if (prev) prev.addEventListener('click', onPrev);
      if (next) next.addEventListener('click', onNext);

      var pauseOn = function () { state.paused = true; };
      var pauseOff = function () { state.paused = false; };
      root.addEventListener('mouseenter', pauseOn);
      root.addEventListener('mouseleave', pauseOff);
      root.addEventListener('focusin', pauseOn);
      root.addEventListener('focusout', pauseOff);

      // Resize handler — re-clone if visible count changed
      var resizeTimer = null;
      var onResize = function () {
        if (resizeTimer) clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          ensureClones(track);
        }, 200);
      };
      window.addEventListener('resize', onResize);

      function startAutoplay() {
        if (root.dataset.autoplay !== 'true') return;
        var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduced) return;
        if (getOriginalTiles(track).length < 2) return;
        var seconds = parseInt(root.dataset.autoplaySpeed, 10);
        if (isNaN(seconds) || seconds < 1) seconds = 5;
        stopAutoplay();
        state.autoplayTimer = setInterval(function () {
          if (!state.paused && !state.animating) scrollBy(1);
        }, seconds * 1000);
      }

      function stopAutoplay() {
        if (state.autoplayTimer) {
          clearInterval(state.autoplayTimer);
          state.autoplayTimer = null;
        }
        if (state.animationTimer) {
          clearTimeout(state.animationTimer);
          state.animationTimer = null;
        }
      }

      startAutoplay();

      // Initialize active dot on load
      updateActiveDot();

      registry.set(root, {
        track: track,
        prev: prev, next: next,
        onPrev: onPrev, onNext: onNext,
        pauseOn: pauseOn, pauseOff: pauseOff,
        onResize: onResize,
        onScroll: onScroll,
        dots: dots,
        dotHandlers: dotHandlers,
        stopAutoplay: stopAutoplay
      });
    }

    function teardown(root) {
      var refs = registry.get(root);
      if (!refs) return;
      if (refs.prev) refs.prev.removeEventListener('click', refs.onPrev);
      if (refs.next) refs.next.removeEventListener('click', refs.onNext);
      root.removeEventListener('mouseenter', refs.pauseOn);
      root.removeEventListener('mouseleave', refs.pauseOff);
      root.removeEventListener('focusin', refs.pauseOn);
      root.removeEventListener('focusout', refs.pauseOff);
      window.removeEventListener('resize', refs.onResize);
      if (refs.track && refs.onScroll) refs.track.removeEventListener('scroll', refs.onScroll);
      if (refs.dots && refs.dotHandlers) {
        for (var i = 0; i < refs.dots.length; i++) {
          refs.dots[i].removeEventListener('click', refs.dotHandlers[i]);
        }
      }
      refs.stopAutoplay();
      if (refs.track) clearClones(refs.track);
      registry.delete(root);
    }

    function initWithin(scope) {
      (scope || document).querySelectorAll('[data-hero-carousel]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initWithin(); });
    } else {
      initWithin();
    }

    document.addEventListener('shopify:section:load', function (e) {
      initWithin(e.target);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      e.target.querySelectorAll('[data-hero-carousel]').forEach(teardown);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
